<!-- headings -->
<div class="block wrap center-m center-s">
    <!-- top titles -->
    <h1 class="m-t-2 c-6 c-12-m c-12-s"
        sizeClass="S: h2, !S: h1"
        *iCms="'title' of content"></h1>
    <div class="c-6 c-12-s m-b-1-s left-x left-l"
         sizeClass="S: p2, !S: p1"
         *iCms="'intro' of content"></div>
    <div class="m-t-1">
        <button class="button-inline-1"
                type="button"
                [zippyOpen]="'tab.0'"
                zippyClass="!underline-color">
            <span class="button__body"
                  [zippyName]="'tab.0'"
                  zippyClass="!col-12 text-decoration-color">{{'Quick Order' | translate}}</span>
        </button>
        &nbsp;&nbsp;
        <span class="col-12">|</span>
        &nbsp;&nbsp;
        <button class="button-inline-1"
                type="button"
                [zippyOpen]="'tab.1'"
                zippyClass="!underline-color">
            <span class="button__body"
                  [zippyName]="'tab.1'"
                  zippyClass="!col-12 text-decoration-color">{{'Import Order' | translate}}</span>
        </button>
    </div>


    <div *ifSize="'!S'"
         class="m-t-7 m-t-6-s button-height"
         [zippy]="'tab.0'"
         [zippyAuto]="true">
        <a class="button-inline-1"
           href="/assets/bulk-order.sample.csv"
           target="_blank">
            <span *iCms="'impoterDownloadCopy' of content"></span>
        </a>
    </div>
    <div class="m-t-7 m-t-6-s button-height"
         [zippy]="'tab.1'">
        <div class="flex flex-middle flex-justify-center-m flex-justify-center-s">
            <button class="pos-relative m-r-8 m-r-0-m m-r-0-s p1 inline-flex flex-middle">
                <i [style.font-size.em]="1.27"
                   class="icon-download m-r-3"></i>

                {{'Choose a file...' | translate}}

                <input type="file"
                       style="opacity:0"
                       class="fill cursor-pointer"
                       (change)="onFileChange($event, true)"
                       accept=".csv">
            </button>
            @if (importProgress) {
            <span class="pos-absolute p-l">{{importProgress}}%</span>
            }
        </div>
        <result [status]="importStatus"
                class="center m-t w-12 block"></result>
    </div>
    @if (erroringSkus?.length) {
    <div>
        @for (errorGroup of erroringSkus; track $index) {
        <div class="m-t">
            <p class="p1 col-2">
                {{errorGroup.error}}
            </p>
            <ul class="m-t-2">
                @for (sku of errorGroup.skus; track $index; let last = $last) {
                <li>{{sku}}</li>
                }
            </ul>
        </div>
        }
        <button class="m-t underline"
                aria-label="Show all"
                (click)="closeInvalidSkus()">{{'Click here' | translate}}</button> {{'to close this warning.' |
        translate}}
    </div>
    }
</div>


<!-- listing -->
<bulk-order-listing class="block m-t-12"
                    [bulk]="bulk"></bulk-order-listing>